import React from 'react';

import './ButtonFilters.scss';

const ButtonFilters = props => (
  <button type="button" className={`button button--round-icon button--filters ${props.extraClass ? `${props.extraClass}` : ''} ${props.filterMenuOpen ? 'button--filters--clicked' : ''}`} onClick={props.onClick}>{props.children}</button>
);

export default ButtonFilters;
